export default {
    getHumanResourceHeaderFields: state => state.humanResourceHeaderFields,
    getHumanResourceFormActions: state => state.humanResourceFormActions,
    getHumanResourceActions: state => state.humanResourceActions,
    getHumanResourceRowActions: state => state.humanResourceRowActions,
    isHumanResourceFormOpen: state => state.humanResourceFormIsOpen,
    isHumanResourceGridOpen: state => state.humanResourceGridIsOpen,

    getQualificationHeaderFields: state => state.qualificationHeaderFields,
    getQualificationFormActions: state => state.qualificationFormActions,
    getQualificationActions: state => state.qualificationActions,
    getQualificationRowActions: state => state.qualificationRowActions,
    isQualificationFormOpen: state => state.qualificationFormIsOpen,
    isQualificationGridOpen: state => state.qualificationGridIsOpen,

    getLanguageHeaderFields: state => state.languageHeaderFields,
    getLanguageFormActions: state => state.languageFormActions,
    getLanguageActions: state => state.languageActions,
    getLanguageRowActions: state => state.languageRowActions,
    isLanguageFormOpen: state => state.languageFormIsOpen,
    isLanguageGridOpen: state => state.languageGridIsOpen,

    getCompanyHeaderFields: state => state.companyHeaderFields,
    getCompanyFormActions: state => state.companyFormActions,

    getFeeHeaderFields: state => state.feeHeaderFields,
    getFeeFormActions: state => state.feeFormActions,
    getFeeActions: state => state.feeActions,
    getFeeRowActions: state => state.feeRowActions,
    isFeeFormOpen: state => state.feeFormIsOpen,
    isFeeGridOpen: state => state.feeGridIsOpen,

}
